import type { ClientsTranslations } from "../interfaces/clients";

export const clientsTranslations: ClientsTranslations = {
  page_title: "Clients",
  page_subtitle: "Manage organizations, their clients, and identity verification status.",
  button_refresh: "Refresh",
  page_loading: "Loading clients...",
  filters_heading: "Filters",
  filters_label_client_type: "Client type",
  filters_placeholder_client_type: "Select client type",
  filters_label_kyc_status: "KYC status",
  filters_placeholder_kyc_status: "Select status",
  filters_label_country: "Country",
  filters_placeholder_country: "Select country",
  filters_label_search: "Search by name",
  filters_placeholder_search: "Search by name...",
  filters_hint: 'Filters are applied when you click "Apply filters".',
  filters_button_apply: "Apply filters",
  filters_button_clear: "Clear filters",
  table_showing_one: "Showing 1 of {{total}}",
  table_showing_many: "Showing {{count}} of {{total}}",
  table_show_label: "Show",
  table_th_type: "Type",
  table_th_name: "Name",
  table_th_email: "Email",
  table_th_country: "Country",
  table_th_kyc: "KYC",
  table_th_created: "Created",
  table_th_actions: "Actions",
  table_empty: "No records.",
  table_type_individual: "Individual",
  table_type_empresa: "Company",
  type_b2c: "B2C",
  type_b2b: "B2B",
  type_b2b2c: "B2B2C",
  kyc_pending: "Pending",
  kyc_in_review: "In review",
  kyc_verified: "Verified",
  kyc_rejected: "Rejected",
  kyc_expired: "Expired",
  pagination_records: "Records {{from}} to {{to}} of {{total}}",
  pagination_total_pages: "Total pages ({{lastPage}})",
  pagination_first_page: "First page",
  pagination_prev_page: "Previous page",
  pagination_next_page: "Next page",
  pagination_last_page: "Last page",

  button_create_client: "Create client",
  button_create_organization: "Create organization",
  modal_create_title: "Create client",
  modal_create_organization_title: "Create organization",
  modal_label_parent_organization: "Organization",
  modal_placeholder_parent_organization: "Select the organization",
  modal_label_client_type: "Client type",
  modal_placeholder_client_type: "Select client type",
  modal_label_first_name: "First name",
  modal_placeholder_first_name: "E.g. John",
  modal_label_last_name: "Last name",
  modal_placeholder_last_name: "E.g. Doe",
  modal_label_company_name: "Company name",
  modal_placeholder_company_name: "E.g. Acme Inc.",
  modal_label_email: "Email",
  modal_placeholder_email: "E.g. email@example.com",
  modal_label_phone: "Phone",
  modal_placeholder_phone: "E.g. +1 555 123 4567",
  modal_label_phone_dial: "Country code",
  modal_placeholder_phone_dial: "Select country",
  modal_label_phone_national: "Number",
  modal_placeholder_phone_national: "Local number only, no spaces",
  modal_label_country: "Country",
  modal_placeholder_country: "Select country",
  modal_label_identification_type: "Identification type",
  modal_placeholder_identification_type: "Select type",
  modal_label_identification_number: "Identification number",
  modal_placeholder_identification_number: "E.g. 123456789",
  modal_cancel: "Cancel",
  modal_create_button: "Create",
  modal_creating: "Creating...",
  modal_close_aria: "Close",
  toast_create_client_success: "Client created successfully.",
  toast_create_organization_success: "Organization created successfully.",
  toast_create_client_duplicate: "This client already exists in this organization.",
  validation_client_type_required: "Client type is required.",
  validation_first_name_required: "First name is required.",
  validation_last_name_required: "Last name is required.",
  validation_company_name_required: "Company name is required.",
  validation_company_name_max: "Maximum 200 characters.",
  validation_company_name_min: "Minimum 2 characters.",
  validation_name_letters_only: "Only letters, spaces, apostrophes and hyphens are allowed.",
  validation_email_required: "Email is required.",
  validation_email_invalid: "Enter a valid email.",
  validation_phone_required: "Phone is required.",
  validation_phone_dial_required: "Select the country calling code.",
  validation_country_required: "Country is required.",
  validation_identification_type_required: "Identification type is required.",
  validation_identification_number_required: "Identification number is required.",
  validation_first_name_max: "Maximum 120 characters.",
  validation_last_name_max: "Maximum 120 characters.",
  validation_email_max: "Maximum 255 characters.",
  validation_phone_max: "Maximum 30 characters.",
  validation_identification_type_max: "Maximum 50 characters.",
  validation_identification_number_max: "Maximum 100 characters.",

  action_view: "View",
  action_accounts_aria: "Client accounts",
  accounts_modal_title: "Accounts — {{name}}",
  accounts_loading: "Loading accounts...",
  accounts_error_load: "Could not load accounts.",
  accounts_empty: "This client has no registered accounts.",
  accounts_section_list: "Registered accounts",
  accounts_section_new: "Register account",
  accounts_btn_create: "Save account",
  accounts_created_at: "Created",
  accounts_payment_method_bank: "Bank",
  accounts_payment_method_crypto: "Crypto wallet",
  accounts_payment_method_binance_pay: "Binance Pay",
  accounts_deleted: "Deleted",
  accounts_toast_success: "Account saved successfully.",
  accounts_toast_error: "Could not save the account.",
  accounts_validation_currency: "Select a currency.",
  accounts_validation_bank: "Select a bank or method.",
  accounts_validation_payment_method: "Select a payment method.",
  accounts_field_alias_label: "Account alias",
  accounts_field_alias_placeholder: "e.g. Main BRL account",
  accounts_validation_alias_max: "Maximum 255 characters.",
  accounts_btn_delete: "Delete",
  accounts_delete_section_heading: "Account to delete",
  accounts_delete_no_metadata: "No additional information",
  accounts_delete_confirm_title: "Delete account",
  accounts_delete_confirm_message:
    "Are you sure you want to delete this account? This action cannot be undone.",
  accounts_delete_final_confirm_title: "Confirm deletion",
  accounts_delete_final_confirm_message:
    "Please confirm again. The account will be permanently deleted when you continue.",
  accounts_delete_cancel: "Cancel",
  accounts_delete_confirm: "Delete",
  accounts_delete_final_confirm_button: "Yes, delete account",
  accounts_toast_delete_success: "Account deleted successfully.",
  accounts_toast_delete_error: "Could not delete the account.",
  view_modal_title: "KYC Management - {{name}}",
  view_label_name: "Name",
  view_label_type: "Type",
  view_label_email: "Email",
  view_label_country: "Country",
  view_label_phone: "Phone",
  view_label_registration_date: "Registration date",
  view_btn_generate_link: "Generate verification",
  view_btn_send_email: "Send by email",
  view_toast_send_email_success: "KYC verification email sent.",
  view_toast_send_email_error: "Could not send the verification email.",
  view_loading: "Loading client...",
  view_error: "Could not load client.",
  view_volver_cliente_padre: "Back to parent client",

  view_btn_delete_client: "Delete client",
  view_delete_client_confirm_title: "Delete client",
  view_delete_client_confirm_message:
    'Are you sure you want to delete the client "{{name}}"? This action cannot be undone.',
  view_delete_client_section_heading: "Client to delete",
  view_delete_client_final_confirm_title: "Confirm deletion",
  view_delete_client_final_confirm_message:
    'Please confirm again. The client "{{name}}" will be permanently deleted when you continue.',
  view_delete_client_cancel: "Cancel",
  view_delete_client_confirm: "Delete",
  view_delete_client_final_confirm_button: "Yes, delete",
  view_toast_delete_client_success: "Client deleted successfully.",
  view_toast_delete_client_error: "Could not delete the client.",
  view_delete_client_blocked_one: "This client has 1 registered bank account. Delete it to continue.",
  view_delete_client_blocked_many:
    "This client has {{count}} registered bank accounts. Delete them to continue.",
  view_delete_client_blocked_action: "View bank accounts",

  view_btn_delete_organization: "Delete organization",
  view_delete_organization_confirm_title: "Delete organization",
  view_delete_organization_confirm_message:
    'Are you sure you want to delete the organization "{{name}}"? Access to its clients and accounts will be lost. This action cannot be undone.',
  view_delete_organization_section_heading: "Organization to delete",
  view_delete_organization_final_confirm_title: "Confirm deletion",
  view_delete_organization_final_confirm_message:
    'Please confirm again. The organization "{{name}}" will be permanently deleted when you continue.',
  view_toast_delete_organization_success: "Organization deleted successfully.",
  view_toast_delete_organization_error: "Could not delete the organization.",
  view_delete_field_country: "Country",
  view_delete_field_phone: "Phone",
  view_danger_zone_action_delete: "Delete",

  action_edit: "Edit client",
  edit_modal_title: "Edit client",
  edit_modal_description: "Update the client's information.",
  edit_loading: "Loading client data...",
  edit_error_load: "Could not load client data.",
  edit_field_type_label: "Client type",
  edit_field_type_individual: "Individual",
  edit_field_type_business: "Business",
  edit_submit_button: "Save changes",
  edit_submitting: "Saving...",
  edit_no_changes: "No changes to save.",
  edit_toast_success: "Client updated successfully.",
  edit_toast_error: "Could not update the client.",

  edit_org_modal_title: "Edit organization",
  edit_org_modal_description: "Update the organization's information.",
  edit_org_label_name: "Organization name",
  edit_org_placeholder_name: "e.g. Acme Inc.",
  edit_org_toast_success: "Organization updated successfully.",
  edit_org_toast_error: "Could not update the organization.",
  validation_org_name_required: "Organization name is required.",
  validation_org_name_min: "Minimum 2 characters.",
  validation_org_name_max: "Maximum 255 characters.",

  // Create client: identity (KYC) fields — Slice 3
  modal_section_company: "Company details",
  modal_section_owner: "Owner details",
  modal_label_birthdate: "Date of birth",
  modal_placeholder_birthdate: "YYYY-MM-DD",
  modal_label_gender: "Gender",
  modal_placeholder_gender: "Select gender",
  gender_male: "Male",
  gender_female: "Female",
  gender_other: "Other",
  modal_label_nationality: "Nationality",
  modal_placeholder_nationality: "Select country",
  modal_label_id_country: "Document country",
  modal_placeholder_id_country: "Select country",
  modal_label_legal_name: "Legal name",
  modal_placeholder_legal_name: "e.g. Acme Inc.",
  modal_label_business_type: "Business type",
  modal_placeholder_business_type: "e.g. LLC",
  modal_label_incorporation_date: "Incorporation date",
  modal_placeholder_incorporation_date: "YYYY-MM-DD",
  modal_label_owner_name: "Owner name",
  modal_placeholder_owner_name: "e.g. Jane Smith",
  modal_label_owner_country_code: "Owner country",
  modal_placeholder_owner_country_code: "Select country",
  modal_label_owner_id_type: "Owner document type",
  modal_placeholder_owner_id_type: "Select type",
  modal_label_owner_id_number: "Owner document number",
  modal_placeholder_owner_id_number: "e.g. 123456789",
  modal_label_owner_address_line1: "Owner address",
  modal_placeholder_owner_address_line1: "e.g. 123 Main St",
  modal_label_owner_city: "Owner city",
  modal_placeholder_owner_city: "e.g. Bogotá",
  modal_label_owner_state: "Owner state / province",
  modal_placeholder_owner_state: "e.g. Cundinamarca",
  modal_label_owner_postal_code: "Owner postal code",
  modal_placeholder_owner_postal_code: "e.g. 110111",
  doc_type_nit: "NIT",
  doc_type_cc: "CC",
  doc_type_ce: "CE",
  doc_type_ppt: "PPT",
  doc_type_passport: "Passport",
  doc_type_dni: "DNI",
  doc_type_le: "LE",
  doc_type_lc: "LC",
  doc_type_ci: "CI",
  doc_type_cuil: "CUIL",
  doc_type_rg: "RG",
  doc_type_cnh: "CNH",
  doc_type_cpf: "CPF",
  doc_type_cnpj: "CNPJ",
  doc_type_rut: "RUT",
  doc_type_ine: "INE",
  doc_type_rfc: "RFC",
  doc_type_ruc: "RUC",
  doc_type_national_id: "National ID",
  doc_type_driver_license: "Driver's license",
  doc_type_residence_permit: "Residence permit",
  doc_type_tax_id: "Tax ID",
  validation_birthdate_required: "Date of birth is required.",
  validation_birthdate_invalid: "Enter a valid date (YYYY-MM-DD).",
  validation_cpf_digits: "The CPF must have 11 digits.",
  validation_cnpj_length: "The CNPJ must have 14 characters.",
  validation_gender_required: "Gender is required.",
  validation_id_country_required: "Document country is required.",
  validation_legal_name_required: "Legal name is required.",
  validation_legal_name_max: "Maximum 255 characters.",
  validation_business_type_required: "Business type is required.",
  validation_business_type_max: "Maximum 100 characters.",
  validation_incorporation_date_required: "Incorporation date is required.",
  validation_incorporation_date_invalid: "Enter a valid date (YYYY-MM-DD).",
  validation_owner_name_required: "Owner name is required.",
  validation_owner_country_code_required: "Owner country is required.",
  validation_owner_id_type_required: "Owner document type is required.",
  validation_owner_id_number_required: "Owner document number is required.",
  validation_owner_address_line1_required: "Owner address is required.",
  validation_owner_city_required: "Owner city is required.",
  validation_owner_state_required: "Owner state / province is required.",
  validation_owner_postal_code_required: "Owner postal code is required.",
  coming_soon: "Coming soon",
  kpi_total_organizations: "Total organizations",
  kpi_total_clients: "Total clients",
  kpi_total_meta: "Result of the current query",
  kpi_verified: "Verified (KYC)",
  kpi_pending_review: "Pending / In review",
  kpi_rejected_expired: "Rejected or expired",
  filters_option_all: "All",
  filters_search_organizations_placeholder: "Search by organization name or email…",
  filters_search_clients_placeholder: "Search by name, email or identification…",
  filters_verified_only: "Verified only",
  filters_chip_search: "Search",
  filters_chip_type: "Type",
  filters_chip_country: "Country",
  filters_chip_remove: "Remove filter {{label}}: {{value}}",
  filters_clear_all: "Clear all",
  orgs_th_organization: "Organization",
  orgs_th_clients: "Clients",
  orgs_th_accounts: "Accounts",
  orgs_th_created: "Created",
  orgs_count_clients: "clients",
  orgs_count_accounts: "accounts",
  orgs_action_view_clients: "View clients",
  orgs_pagination_summary: "Showing {{from}}–{{to}} of {{total}} organizations",
  clients_pagination_summary: "Showing {{from}}–{{to}} of {{total}} clients",
  pagination_show_label: "Show",
  empty_no_results_title: "No results match these filters",
  empty_no_results_description: "Try adjusting the search or removing some active filters.",
  empty_organizations_title: "No organizations yet",
  empty_organizations_description: "Create the first organization to start managing clients.",
  empty_clients_title: "No clients yet",
  empty_clients_description: "Create the first client of this organization to start operating.",
  error_retry: "Retry",
  drilldown_back: "Back",
  drilldown_accounts: "Accounts",
  drilldown_edit_organization: "Edit organization",
  wizard_step_type: "Type",
  wizard_step_identity: "Identity",
  wizard_step_details: "Details",
  wizard_step_verify: "Verify",
  wizard_step_company: "Company data",
  wizard_step_contact: "Contact & brand",
  wizard_step_owner: "Legal owner",
  wizard_progress_aria: "Wizard progress",
  wizard_back: "Back",
  wizard_continue: "Continue",
  button_create_new: "Create new",
  modal_create_entity_title: "Create new",
  choice_entity_description: "Select what you want to register.",
  choice_card_organization_title: "Organization",
  choice_card_organization_description: "Register a business client and get its verification link.",
  choice_card_client_title: "Client",
  choice_card_client_description: "Register a person or business under an organization.",
  drawer_client_description: "Choose the type of client.",
  drawer_client_individual_description: "Individual identity details.",
  client_type_card_individual_description: "A natural person.",
  client_type_card_business_description: "A company or legal entity.",
  org_success_title: "Organization created",
  org_success_subtitle: "Share the verification link below.",
  org_success_text: "{{name}} was created successfully and its identity was registered.",
  org_success_kyc_pending:
    "Identity verification (KYC) was started automatically. The status will update as the process moves forward.",
  org_success_done: "Done",
  wizard_step_account: "Account",
  client_success_title: "Client registered",
  client_success_subtitle: "Share the verification link.",
  client_success_subtitle_account: "Share the verification link and add an account if you need one.",
  client_success_text: "{{name}} was registered successfully and their identity was recorded.",
  client_success_kyc_pending:
    "Identity verification (KYC) is pending. You can generate the link later from the client detail.",
  client_success_skip: "Skip for now",
  client_success_account_heading: "Add a {{currency}} account (optional)",
  client_success_account_hint:
    "The account will be set as the destination of this dispersal; you can send once the client completes KYC verification.",
  accounts_drawer_assign_to: "The account will be assigned to {{name}}.",
  kyc_link_title: "KYC verification link",
  kyc_link_hint: "Share this link to complete the Coloca verification. Do not share it publicly.",
  kyc_link_hint_expires: "This link is valid until {{date}}. Do not share it publicly.",
  kyc_link_copy: "Copy link",
  kyc_link_copied: "Copied",
  kyc_section_eyebrow: "Verification",
  kyc_section_title: "KYC verification",
  kyc_section_sub: "Identity verification status and the link to complete it.",
  kyc_verified_on: "Verification completed on {{date}}.",
  kyc_documents_heading: "Documents",
  kyc_document_view: "View",
  kyc_no_link: "There is no active verification link for this identity.",
  kyc_rejection_reason: "Rejection reason: {{reason}}",
  kyc_btn_regenerate: "Regenerate link",
  edit_identity_title: "Verified identity",
  edit_identity_full_name: "Full name",
  edit_identity_document: "Document",
  edit_identity_birthdate: "Date of birth",
  edit_identity_incorporation_date: "Incorporation date",
  edit_identity_locked_caption: "Identity data is verified and cannot be modified from here.",
  edit_section_contact: "Contact details",
};
